import { Component, OnInit, inject } from '@angular/core';
import { Analytics } from '@core/services/analytics';

@Component({
  selector: 'app-complete-submission',
  templateUrl: './complete-submission.html',
})
export class CompleteSubmission implements OnInit {
  private readonly analytics = inject(Analytics);

  ngOnInit(): void {
    // Track exam completion
    this.analytics.trackExamCompleted('manual');
  }
}
